<template>
  <div>
    <div
      class="text-xs-left pl-1 pb-2"
    >
      Password must have:
      <ul
        class="pl-3"
      >
        <li>At least 8 total characters</li>
        <li>At least one uppercase letter</li>
        <li>At least one lowercase letter</li>
        <li>At least one number</li>
      </ul>
    </div>
    <div
      v-if="badPassword"
      class="red--text"
    >
      Password does not meet minimum requirements
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PasswordRequirements',
    props: {
      badPassword: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
